



































import Vue from 'vue';
import Component from 'vue-class-component';
import ConfettiBackground from '@/components/Layout/SystemNotification/Template/components/ConfettiBackground.vue';
import closeIcon from '@/assets/mission-popup/close.png';
import missionClearIcon from '@/assets/mission-popup/mission-clear.png';
import cloudIcon from '@/assets/mission-popup/cloud.png';
import cup1Icon from '@/assets/mission-popup/cup-1.png';
import cup2Icon from '@/assets/mission-popup/cup-2.png';
import cup3Icon from '@/assets/mission-popup/cup-3.png';
import checkIcon from '@/assets/mission-popup/check.png';
import templateMixin from './templateMixin';

@Component<MissionComplete>({
  components: { ConfettiBackground },
  mixins: [templateMixin],
})
export default class MissionComplete extends Vue {
  close: () => void;
  closeIcon = closeIcon;
  missionClearIcon = missionClearIcon;
  cloudIcon = cloudIcon;
  cup1Icon = cup1Icon;
  cup2Icon = cup2Icon;
  cup3Icon = cup3Icon;
  checkIcon = checkIcon;

  get getCup() {
    switch (Number(this.$attrs.cupLevel)) {
      case 1:
        return cup1Icon;
      case 2:
        return cup2Icon;
      case 3:
        return cup3Icon;
      default:
        return cup1Icon;
    }
  }

  directRouteMission() {
    this.close();
    setTimeout(async () => {
      await this.$router.push('/mission');
    }, 500);
  }
}
